class BlogGuideProductsList extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.blog-guide-products-list__swiper');
    this.mobileQuery = window.matchMedia('(max-width: 767px)');
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    if (!this.swiperEl) return;

    this.mobileQuery.addEventListener('change', this.handleChange);

    // Swiper auto-initializes from its attributes. When it starts life hidden
    // (desktop grid mode for <=4 products), its dimensions are 0. Refresh once
    // it is defined so widths are correct as soon as it becomes visible.
    if (customElements.get('swiper-container')) {
      this.refresh();
    } else {
      customElements.whenDefined('swiper-container').then(() => this.refresh());
    }
  }

  disconnectedCallback() {
    this.mobileQuery.removeEventListener('change', this.handleChange);
  }

  handleChange() {
    this.refresh();
  }

  refresh() {
    requestAnimationFrame(() => {
      const swiper = this.swiperEl && this.swiperEl.swiper;
      if (swiper) swiper.update();
      // Re-measure title + price after slide widths settle
      if (window.PlpCardLayout) {
        window.PlpCardLayout.update(this);
      }
    });
  }
}

if (!customElements.get('blog-guide-products-list')) {
  customElements.define('blog-guide-products-list', BlogGuideProductsList);
}

class BlogGuideExpertAdvices extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.blog-guide-expert-advices__swiper');
    this.mobileQuery = window.matchMedia('(max-width: 767px)');
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    if (!this.swiperEl) return;
    this.mobileQuery.addEventListener('change', this.handleChange);
    if (customElements.get('swiper-container')) {
      this.refresh();
    } else {
      customElements.whenDefined('swiper-container').then(() => this.refresh());
    }
  }

  disconnectedCallback() {
    this.mobileQuery.removeEventListener('change', this.handleChange);
  }

  handleChange() {
    this.refresh();
  }

  refresh() {
    requestAnimationFrame(() => {
      const swiper = this.swiperEl && this.swiperEl.swiper;
      if (swiper) swiper.update();
    });
  }
}

if (!customElements.get('blog-guide-expert-advices')) {
  customElements.define('blog-guide-expert-advices', BlogGuideExpertAdvices);
}
